<template>
  <data-table :service="ClientService"
              v-show="showTable"
              :columns="columns"
              :entity="entity"
              :sync-route="false"
              :filters="filters"
              :go-to-details-on-row-click="false"
              operations=""
              :clickable="false"
              @no-data="showTable = false"
              ref="table">
    <template slot="table-header-left">
      <h6>{{$t('dashboard.list.clients')}}</h6>
    </template>
    <template slot="updated_at" slot-scope="{row}">
      {{$formatDate(row.updated_at, FRIENDLY_DATE_FORMAT)}}
    </template>
    <template slot="name" slot-scope="{row}">
      {{row.name}}
    </template>
    <template slot="extra-buttons" slot-scope="{row, index}">
      <el-select class="select-default"
                 size="small"
                 :value="row.action || deafaultOperation"
                 @change="val => onActionChange(val, row)">
        <el-option class="select-default"
                   v-for="option in operations"
                   :key="option.value"
                   :label="option.label"
                   :value="option.value">
        </el-option>
      </el-select>
    </template>
  </data-table>

</template>
<script>
  import { Select, Option } from 'element-ui'
  import BaseDropdown from 'src/components/BaseDropdown'
  import ClientService from 'src/services/ClientService'
  import entities from 'src/config/entities'
  import { FRIENDLY_DATE_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'dashboard-client-list',
    components: {
      BaseDropdown,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data () {
      return {
        FRIENDLY_DATE_FORMAT,
        ClientService,
        entity: entities.CLIENT,
        showTable: false
      }
    },
    computed: {
      columns () {
        return this.tableColumns || [
          {
            prop: 'updated_at',
            label: this.$t('dashboard.labels.client.date'),
            sortable: true
          },
          {
            prop: 'name',
            label: this.$t('dashboard.labels.client.client'),
            sortable: true
          }
        ]
      },
      operations () {
        return [
          {
            label: this.$t('generic.verify'),
            value: 'verify'
          },
          {
            label: this.$t('generic.decline'),
            value: 'decline'
          }
        ]
      },
      deafaultOperation () {
        return this.$t('generic.view')
      },
      filters () {
        return [
          {
            key: 'match[status]',
            value: 'check'
          }
        ]
      }
    },
    methods: {
      onActionChange (val, row) {
        this.$set(row, 'action', val)
        if (val === 'verify') {
          this.verifyClient(row)
        } else {
          this.declineClient(row)
        }
      },
      refreshTable() {
        this.$refs.table.getTableData();
      },
      async verifyClient (row) {
        await ClientService.verify(row.uuid, {status: 'success'});
        this.refreshTable();
      },
      async declineClient (row) {
        await ClientService.verify(row.uuid, {status: 'blocked'});
        this.refreshTable();
      }
    }
  }
</script>
<style>
</style>


